/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ContentMasterWawiExtendedFieldView = {
    /**
     * Field category discriminator. attribut = regular Wawi attribute, eigene = Eigenes Feld (tAttribut.nIstFreifeld = 1), merkmal = Merkmal/MerkmalWert.
     */
    type?: ContentMasterWawiExtendedFieldView.type;
    /**
     * API key for save-draft / apply (e.g. wawiAttr_123, wawiMerkmal_5, wawiMerkmalWert_42)
     */
    fieldApiName?: string;
    /**
     * dbo.tArtikelAttribut.kArtikelAttribut (attribut/eigene only)
     */
    kArtikelAttribut?: number | null;
    /**
     * dbo.tAttribut.kAttribut (attribut/eigene only)
     */
    kAttribut?: number | null;
    /**
     * dbo.tArtikelAttribut.kShop (attribut/eigene only)
     */
    kShop?: number | null;
    /**
     * dbo.tAttribut.nIstMehrsprachig = 1 (attribut/eigene only)
     */
    isMultilingual?: boolean | null;
    /**
     * dbo.tAttribut.nReadOnly = 1 (attribut/eigene only)
     */
    isReadOnly?: boolean | null;
    /**
     * dbo.tAttribut.cAttributId (attribut/eigene only)
     */
    cAttributId?: string | null;
    /**
     * 0=int, 1=decimal, 2=varchar, 3=datetime (attribut/eigene only)
     */
    nDatenTyp?: number | null;
    /**
     * dbo.tAttributSprache.cName for kSprache (attribut/eigene only). Eigene Felder are usually nIstMehrsprachig=0 and only have a row in one kSprache; in that case the requested-language row is preferred and any non-empty cName from another kSprache is used as fallback (mirrors JTL DEPRECATED.ifArtikelAttributEinsprachig nIstFreifeld=1 branch).
     */
    name?: string | null;
    /**
     * dbo.tArtikelAttributSprache.cWertVarchar (attribut/eigene only)
     */
    cWertVarchar?: string | null;
    /**
     * dbo.tArtikelAttributSprache.nWertInt (attribut/eigene only)
     */
    nWertInt?: number | null;
    /**
     * dbo.tArtikelAttributSprache.fWertDecimal as string (attribut/eigene only)
     */
    fWertDecimal?: string | null;
    /**
     * dbo.tArtikelAttributSprache.dWertDateTime ISO 8601 (attribut/eigene only)
     */
    dWertDateTime?: string | null;
    /**
     * Single-line representation for editors / snapshots (attribut/eigene only)
     */
    displayValue?: string | null;
    /**
     * Parsed dbo.tAttributSprache.cWertListe picklist options for this language; null when unrestricted free text (attribut/eigene only)
     */
    allowedValues?: Array<string> | null;
    /**
     * True when `allowedValues` is non-empty (attribut/eigene only)
     */
    hasFixedOptions?: boolean | null;
    /**
     * Live max char length for the underlying Wawi value column. Populated for varchar attributes / Eigene Felder (`nDatenTyp = 2`) from `INFORMATION_SCHEMA.COLUMNS` of `dbo.tArtikelAttributSprache.cWertVarchar`. Positive integer for `NVARCHAR(N)`, `null` for `NVARCHAR(MAX)`. Always `null` for non-varchar types (int / decimal / datetime) and for Merkmale (option-based, no char limit).
     */
    maxLength?: number | null;
    /**
     * Resolved dbo.tMerkmal.kMerkmal (merkmal only)
     */
    kMerkmal?: number | null;
    /**
     * All dbo.tArtikelMerkmal.kMerkmalWert ids currently assigned to this article for this Merkmal, sorted ASC. A single element for single-value Merkmal; multiple for multi-value (e.g. Verwendung). (merkmal only)
     */
    kMerkmalWerte?: Array<number> | null;
    /**
     * Convenience copy of `kMerkmalWerte[0]` (sorted ASC). Prefer `kMerkmalWerte`. (merkmal only)
     */
    kMerkmalWert?: number | null;
    /**
     * dbo.tMerkmalSprache.cName (merkmal only)
     */
    merkmalName?: string | null;
    /**
     * Localized labels (dbo.tMerkmalWertSprache.cWert) for each id in `kMerkmalWerte`, in the same order. (merkmal only)
     */
    merkmalWertTexts?: Array<string> | null;
    /**
     * Convenience copy of `merkmalWertTexts[0]`. Prefer `merkmalWertTexts`. (merkmal only)
     */
    merkmalWertText?: string | null;
    /**
     * Comma-separated kMerkmalWert ids, sorted ASC, no duplicates — the canonical editable value for save-draft / apply / AI. Example for multi-value Verwendung: "42,43,44,46,47,68". Empty string means "no values assigned". (merkmal only)
     */
    draftValue?: string | null;
    /**
     * Allowed kMerkmalWert values with labels (merkmal only)
     */
    merkmalWertOptions?: Array<{
        kMerkmalWert?: number;
        label?: string;
    }> | null;
};
export namespace ContentMasterWawiExtendedFieldView {
    /**
     * Field category discriminator. attribut = regular Wawi attribute, eigene = Eigenes Feld (tAttribut.nIstFreifeld = 1), merkmal = Merkmal/MerkmalWert.
     */
    export enum type {
        ATTRIBUT = 'attribut',
        EIGENE = 'eigene',
        MERKMAL = 'merkmal',
    }
}

